import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CTA_URL } from "@/lib/copy";
import { ArrowUpRight } from "lucide-react";

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.7);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          key="sticky-cta"
          href={CTA_URL}
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 30, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 30, scale: 0.9 }}
          transition={{ duration: 0.4, ease: [0.2, 0.9, 0.2, 1] }}
          className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[var(--pink)] px-5 py-3 font-mono text-[11px] font-bold uppercase tracking-super text-black shadow-[0_10px_40px_rgba(255,16,122,0.35)] transition hover:bg-white hover:text-[var(--pink)] md:px-6 md:py-3.5"
          data-testid="sticky-cta-button"
        >
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-black/40" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-black" />
          </span>
          Acessar
          <ArrowUpRight className="h-3.5 w-3.5" strokeWidth={2.4} />
        </motion.a>
      )}
    </AnimatePresence>
  );
}
